





















































































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Location from '@/services/Location';

@Component({})
export default class Hours extends Vue {
	@Prop({default: {} as Location}) readonly location !: Location;

	get displayAtmHours(): boolean {
		return (
			(this.location.atm24Hours) ||
			(this.location.atmHours.length > 0)
		);
	}

	get displayDriveThroughHours(): boolean {
		return (
			(!this.location.driveThroughSameAsLobby && (this.location.driveThroughHours.length > 0)) ||
			(this.location.driveThroughSameAsLobby && (this.location.lobbyHours.length > 0))
		);
	}

	get displayLobbyHours(): boolean {
		return this.location.lobbyHours.length > 0;
	}

	get atmHours(): Array<object> {
		if (this.location.atm24Hours) {
			return [];
		}

		return this.location.atmHours;
	}


	get driveThroughHours(): Array<object> {
		if (this.location.driveThroughSameAsLobby) {
			return this.location.lobbyHours;
		}

		return this.location.driveThroughHours;
	}

	get lobbyHours(): Array<object> {
		return this.location.lobbyHours;
	}

}
